import { Post, PostWithDetails, PublicPost } from '../../domain/models';
import { PostRepository } from '../../domain/repositories';
import { PostDataSource } from '../datasources/PostDataSource';
import { postEntityToModel, postWithDetailsEntityToModel, publicPostEntityToModel } from '../entities';

export class PostRepositoryImpl implements PostRepository {
  constructor(private dataSource: PostDataSource) {}

  async create(
    userId: string,
    content: string,
    imageUrl?: string,
    tournamentId?: string
  ): Promise<Post> {
    const entity = await this.dataSource.create(userId, content, imageUrl, tournamentId);
    return postEntityToModel(entity);
  }

  async getFeed(userId: string, limit?: number, offset?: number): Promise<PostWithDetails[]> {
    const entities = await this.dataSource.getFeed(userId, limit, offset);
    return entities.map(postWithDetailsEntityToModel);
  }

  async getPublicById(postId: string): Promise<PublicPost | null> {
    const entity = await this.dataSource.getPublicById(postId);
    if (!entity) return null;
    return publicPostEntityToModel(entity);
  }

  async getById(postId: string): Promise<PostWithDetails | null> {
    const entity = await this.dataSource.getById(postId);
    if (!entity) return null;
    return postWithDetailsEntityToModel(entity);
  }

  async getUserPosts(targetUserId: string, requestingUserId: string, limit?: number, offset?: number): Promise<PostWithDetails[]> {
    const entities = await this.dataSource.getUserPosts(targetUserId, requestingUserId, limit, offset);
    return entities.map(postWithDetailsEntityToModel);
  }

  async getTournamentPosts(tournamentId: string, requestingUserId: string, limit?: number, offset?: number): Promise<PostWithDetails[]> {
    const entities = await this.dataSource.getTournamentPosts(tournamentId, requestingUserId, limit, offset);
    return entities.map(postWithDetailsEntityToModel);
  }

  async update(postId: string, content: string, imageUrl?: string): Promise<Post> {
    const entity = await this.dataSource.update(postId, content, imageUrl);
    return postEntityToModel(entity);
  }

  async delete(postId: string): Promise<void> {
    await this.dataSource.delete(postId);
  }

  async likePost(postId: string, userId: string): Promise<void> {
    await this.dataSource.likePost(postId, userId);
  }

  async unlikePost(postId: string, userId: string): Promise<void> {
    await this.dataSource.unlikePost(postId, userId);
  }
}
